/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */

import { setKeyBattery } from '@/api/KeyApi';
import { formatMessage } from '@/i18n';
import { getKeyTypeByDeviceinfo, isSuppoutMultiTask } from '@/tool/keyfun';
import { getDistlic, getProfile, isWMAdvancedUnlock } from '@/tool/profile';

import config from './config';
import NewSocket from './Socket';
// import { generateTimeBlocks } from './TaskTimeBlocksUtil';

const url = config.websocketUrl;

// 国内国外标志
// 目前根据系统语言
// const sign = (navigator.language || navigator.browserLanguage).startsWith('zh') ? 0 : 1;
// 读取钥匙数据后清空数据
const clearFlag = config.clearAfterRead;
// 设置钥匙模式后清空黑名单标记
// const resetFlag = false;

const socket = new NewSocket();

// 连接websocket接口
export const connect = () => {
  // socket = new Socket();
  return socket.connect(url);
};

// 断开websocket接口
export const disconnect = () => {
  return socket.disconnect();
};

export const stopReconnect = () => {
  return socket.stopReconnect();
};

export const initSdk = secret => {
  // console.log(secret);
  // TODO: overseas应该加密一下，不然也太容易改了...
  const sign = getProfile().overseas ? 1 : 0;
  return socket.reigster('InitSdk', {
    secret,
    sign,
    lic: getDistlic() || undefined,
  });
};

export const releaseSdk = () => {
  // WM暂时没有releaseSDK的接口
  return Promise.resolve();
};

// 读取钥匙信息
// 1.钥匙id 2.钥匙类型 3.钥匙时间
// 4.钥匙模式 5.黑名单标记 blacklistFlag 6.国内外标记（建议把verify换个别的属性，比如flag等） 7.版本号等其他基础信息
// 加入一个是否正在执行添加钥匙操作的标志，默认未false；
// 在添加钥匙时，忽略FK04单任务钥匙和多任务软件通讯时的不匹配提示；
// 2024-12-23添加
// 钥匙硬件版本说明：
// 老版本钥匙：data.device == 1281 ~ 1284，其中data.ver >= 257时，支持多任务，及任务模式转换；
// 新版本钥匙：data.device == 1285 ~ 1288，其中data.ver == 260、261、>= 516时，支持多任务，及任务模式转换；
// EK系列钥匙：data.device >= 1290，都支持多任务，及任务模式转换；
// data.ver：257——仅指纹钥匙支持多任务，260——仅指纹、指纹蓝牙支持多任务，261——都支持多任务，>=516的都支持多任务、并且支持钥匙头充电；
// 目前，多任务软件仅支持带指纹功能的钥匙
export const readKeyInfo = (isAdding = false) => {
  // return socket.send('ReadKeyInfo');
  return new Promise((resolve, reject) => {
    socket.send('ReadKeyInfo').then(
      data => {
        // 原判断逻辑
        // // 新钥匙版本（data.ver == 261 或者 data.ver >= 516）和 EK系列钥匙 都支持多任务，
        // // 老钥匙版本（data.ver < 516 && data.ver != 261）, 还按之前的逻辑进行判断处理
        // if (data.ver === 261 || data.ver >= 516) {
        //   // 当钥匙任务模式与当前系统不匹配时，提示需重新添加至系统
        //   if (!isAdding && data.multitask !== isWMAdvancedUnlock()) {
        //     reject(formatMessage('hardware.device.unmatch'));
        //   }
        // } else {
        //   // 老钥匙版本还按下面的逻辑进行判断处理
        //   // 不是 FK04钥匙 但是 是多任务的软件
        //   // 1287，新指纹模块的指纹钥匙，1284，旧指纹模块的指纹钥匙
        //   // 1288，指纹蓝牙钥匙
        //   if (data.device !== 1287 && data.device !== 1288 && isWMAdvancedUnlock()) {
        //     reject(formatMessage('hardware.device.incompatible'));
        //   }
        //   // FK04单任务钥匙 多任务软件
        //   // if (!isAdding && data.device === 1287 && !data.multitask && isWMAdvancedUnlock()) {
        //   // FK04单任务钥匙多任务软件 或 FK04多任务钥匙单任务软件
        //   // 1287，新指纹模块的指纹钥匙，1284，旧指纹模块的指纹钥匙
        //   if (
        //     !isAdding &&
        //     (data.device === 1287 || data.device === 1288) &&
        //     data.multitask !== isWMAdvancedUnlock()
        //   ) {
        //     if (data.ver >= 257) {
        //       // 只有257的才支持转换，提示重新添加才有意义，否则直接提示不兼容；
        //       reject(formatMessage('hardware.device.unmatch'));
        //     } else {
        //       reject(formatMessage('hardware.device.incompatible'));
        //     }
        //   }
        // }
        // if (data.device >= 1290) {
        //   data.type = getKeyTypeByDeviceinfo(data);
        // }

        // 最新判断逻辑 2026-01-12
        // 判断当前系统是否多任务
        const isMultiTask = isWMAdvancedUnlock();

        // 目前只有带指纹功能的钥匙，才支持多任务软件
        let isFinger = false;
        // 带指纹功能的钥匙类型
        const fkDevices = [1283, 1284, 1287, 1288];
        if (data.support && data.support.includes('finger')) {
          // EK系列钥匙才有support属性（device >= 1290）
          isFinger = true;
        } else if (data.device && fkDevices.includes(data.device)) {
          isFinger = true;
        }
        // 多任务软件 && 非指纹功能钥匙 && 非应急钥匙时，提示不兼容
        if (isMultiTask && !isFinger && data.mode !== 1) {
          reject(formatMessage('hardware.device.incompatible'));
        }

        // 当不是应急钥匙 && 钥匙任务模式与当前系统不匹配时，提示需重新添加至系统
        // data.mode !== 1 表示不是应急钥匙
        if (!isAdding && data.multitask !== isMultiTask && data.mode !== 1) {
          // 判断当前钥匙版本是否支持多任务
          const isSuppoutMultiTaskKey = isSuppoutMultiTask(data);
          if (isSuppoutMultiTaskKey) {
            // 钥匙支持多任务，提示重新添加至系统
            reject(formatMessage('hardware.device.unmatch'));
          } else {
            // 钥匙不支持多任务，提示不兼容
            reject(formatMessage('hardware.device.incompatible'));
          }
        }
        // EK系列钥匙设置type
        if (data.device >= 1290) {
          data.type = getKeyTypeByDeviceinfo(data);
        }

        // 通讯时更新钥匙电量
        // 旧通讯组件无法返回电量信息
        if (data.power !== null && data.power !== undefined) {
          setKeyBattery(data.id, data.power);
        }

        // TODO: 这里判断条件太换乱了，使用了多个状态 device（fk04判断依据），ver（支持多任务切换依据），multitask（多任务依据）
        // 后续通讯端统一一下；
        resolve(data);
      },
      err => reject(err)
    );
  });
};

// 读取钥匙内的事件，采集模式也用这个
export const readKeyRecords = (clearAfterRead = clearFlag) => {
  // 在读取记录的过程中服务器会推送 读取进度命令
  // {"cmd":"OnReadData","data":{"total":int,"current":int}}
  //   total 为总记录包数，current 为当前包数
  return socket.send('ReadKeyRecords', {
    clearFlag: clearAfterRead,
    type: 'text',
  });
};
// 读取钥匙数据，应急钥匙删除时使用，为了支持-4118时不提示，直接在钥匙列表中删除数据
export const readKeyInfoEx = () => {
  // return socket.send('ReadKeyInfo');
  return new Promise((resolve, reject) => {
    socket
      .send('ReadKeyInfoEx', {
        // 用于数据识别
        clearFlag: 'readKeyInfoEx',
      })
      .then(
        data => {
          console.log('ReadKeyInfoEx', data);
          resolve({ ...data });
        },
        err => reject(err)
      );
  });
};

export const clearKeyRecords = () => {
  return socket.send('ClearRecords');
};

export const createBlankKey = () => {
  // TODO: WM已经提供了clearKeyRecords，这里是否还有必要加入一个创建某种钥匙时顺便清空记录的标志？
  return socket.send('SetKeyMode', {
    // 制作空白钥匙后，清除所有records
    clearFlag: true,
    mode: 0,
  });
};

export const createAdvancedUnlockKey = async (tasks, offline, characteristics) => {
  try {
    const prevStep =
      characteristics && characteristics.length > 0
        ? setFingerprintKeyCharacteristics
        : () => Promise.resolve();
    await prevStep(characteristics, true);

    const offlineStep = () => socket.send('SetOffline', offline ? 1 : 0);
    // 旧版通讯组件中SetOffline函数不支持
    // 借助try catch在不支持时直接跳过
    // TODO: 后续考虑：1. 加入通讯组件版本判断 2.优化后通讯组件offline参数传递方式（直接写在setTasks内）
    try {
      await offlineStep();
    } catch (offlineNotSupportError) {
      console.log('offlineNotSupportError', offlineNotSupportError);
    }

    const data = {
      tasks,
    };
    return socket.send('setTasks', data); // TODO: S大写
  } catch (err) {
    return Promise.reject(err);
  }
};

export const createUnlockKey = (
  beginDate,
  endDate,
  timeRanges,
  locksList,
  offline,
  passwords,
  characteristics
) => {
  // console.log(beginDate, endDate, beginTime, endTime, locksList, passwords, characteristics);
  console.log(characteristics);
  const prevStep =
    characteristics && characteristics.length > 0
      ? setFingerprintKeyCharacteristics
      : () => Promise.resolve();
  return prevStep(characteristics).then(
    () => {
      const data = {
        mode: 10,
        params: {
          passwords, // FE: [['A123','A456'], ['B123','B456']]
          lockIds: locksList,
          timeBlocks: [
            {
              from: beginDate,
              to: endDate,
              times: timeRanges.map(range => ({
                from: range[0],
                to: range[1],
              })),
            },
          ],
          offline: offline || 0,
        },
      };
      console.log(data);
      return socket.send('SetKeyMode', data);
    },
    err => {
      return Promise.reject(err);
    }
  );
  // const data = {
  //     mode: 10,
  //     params: {
  //         passwords, //FE: [['A123','A456'], ['B123','B456']]
  //         lockIds: locksList,
  //         timeBlocks: [{
  //             from: beginDate,
  //             to: endDate,
  //             times: [{
  //                 from: beginTime,
  //                 to: endTime
  //             }]
  //         }],
  //     }
  // }
  // console.log(data);
  // return socket.send('SetKeyMode', data);
};

// 2025-12-08 新的任务模式 beginDate endDate 精确到时分秒，timeBlocks会自动生成多个时段
export const createUnlockKeyForMultiTimeBlocks = (
  taskId,
  timeBlocks,
  locksList,
  offline,
  passwords,
  characteristics
) => {
  console.log(characteristics);
  const prevStep =
    characteristics && characteristics.length > 0
      ? setFingerprintKeyCharacteristics
      : () => Promise.resolve();
  return prevStep(characteristics).then(
    () => {
      const data = {
        mode: 10,
        params: {
          taskId,
          passwords, // FE: [['A123','A456'], ['B123','B456']]
          lockIds: locksList,
          timeBlocks, // generateTimeBlocks(beginDate, endDate, timeRanges),
          offline: offline || 0,
        },
      };
      console.log(data);
      return socket.send('SetKeyMode', data);
    },
    err => {
      return Promise.reject(err);
    }
  );
};

export const createReadLockNoKey = () => {
  return socket.send('SetKeyMode', {
    mode: 19,
  });
};

// 第一个参数在WM里没用，是HM里面的keyid参数
export const createBlacklistKey = (_, keyIds) => {
  return socket.send('SetKeyMode', {
    mode: 18,
    params: {
      keyIds,
    },
  });
};

export const createReadLockEventKey = () => {
  return socket.send('SetKeyMode', {
    mode: 16,
  });
};

export const clearKeyBlacklistFlag = () => {
  return socket.send('ClearBlacklistFlag');
};

export const setKeySecret = () => {
  return socket.send('SetKeySecret');
};

export const clearKeySecret = () => {
  return socket.send('ClearKeySecret');
};

export const createSetLockSecretKey = () => {
  return socket.send('SetLockSecret');
};

export const createClearLockSecretKey = () => {
  return socket.send('ClearLockSecret');
};

export const createEmergencyKey = (from, to) => {
  return socket.send('SetKeyMode', {
    mode: 9,
    params: {
      from, // YYYY-MM-DD HH:mm:ss
      to, // YYYY-MM-DD HH:mm:ss
    },
  });
};

// TODO: 这个id值硬件中有用？后期考虑体现在硬件通信接口中；
const FIXED_FINGER_ID = 99;
// 采集指纹时的采集次数，默认为6；
const COLLECT_TIMES = 6;

export const createCollectFingerPrintKey = () => {
  return socket.send('GetFingerprint', {
    fingerId: FIXED_FINGER_ID,
    count: COLLECT_TIMES,
  });
};

// isWorkerBindFingers 参数区别是使用workerid对应指纹特征值，还是使用fingerid对应指纹特征值
export const setFingerprintKeyCharacteristics = (characteristics, isWorkerBindFingers) => {
  const data = !isWorkerBindFingers
    ? characteristics.map(item => ({
        // fingerId: FIXED_FINGER_ID,
        fingerId: item.id,
        fingerFea: item.fea,
      }))
    : characteristics.map(item => ({
        workerId: item.workerId,
        fingerFeas: item.fingerFeas,
      }));
  return socket.send('SetFingerprint', data);
};

export const clearFingerPrints = () => {
  return socket.send('RemoveFingerprint', []);
};

export const createSetFireLockDirectionKey = direction => {
  return socket.send('SetUnlockDirection', {
    right: direction === 'right',
  });
};

export const startDynamicReadLockNoKey = () => {
  return socket.send('StartReadLockId');
};

export const stopDynamicReadLockNoKey = () => {
  return socket.send('StopReadLockId');
};

export const setTaskType = multiTask => {
  console.log('multiTask', multiTask);
  return socket.send('SetTaskType', multiTask);
};

export const setHost = (host, port) => {
  return socket.send('SetHost', { host, port });
};

export const setMobileParam = params => {
  return socket.send('SetMobileParam', {
    apn: params.apn,
    user: params.username,
    password: params.password,
    pin1: params.pin1,
    pin2: params.pin2,
  });
};

export const setKeyVolume = volume => {
  console.log(`SetKeyVolume:${volume}`);
  return socket.send('SetKeyVolume', {
    volum: volume,
  });
};

export const setFingerValidity = (timeout, mode) => {
  console.log(`SetFingerValidity:${timeout}${mode}`);
  return socket.send('SetFingerValidity', {
    timeout,
    mode,
  });
};

export const setAutoPowerOff = offtime => {
  return socket.send('SetAutoPowerOff', offtime);
};

// 针对 772 以上版本钥匙，是否支持任务id（调用该方法前，需要清除钥匙中的记录）
//  {"cmd":"EnableTask","data":bool}
export const setKeyEnableTask = enabled => {
  return socket.send('EnableTask', enabled);
};
